export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0036s_0000_Black-&-White-27.7c94a67f.png";